export function arrayToQueryParameter(key: string, list: string[]) {
  return list.reduce((acc, item) => `${acc}${key}=${item}&`, '');
}

export function objectToQuery(object: { [key: string]: undefined | string | string[] }) {
  return Object.entries(object)
    .filter(([key, value]) => value !== undefined) // remove any undefined values
    .reduce((acc, [key, value]) => {
      if (Array.isArray(value)) {
        return `${acc}${arrayToQueryParameter(key, value)}`;
      } else {
        return `${acc}${key}=${value}&`;
      }
    }, '?')
    .slice(0, -1); // remove extra & from the end
}

let searchParams: URLSearchParams | undefined;
/**
 * Gets the value for the given key in the current URL
 */
export function getQueryParameter(key: string) {
  if (searchParams === undefined) {
    searchParams = new URLSearchParams(window.location.search);
  }

  return searchParams.get(key);
}
